module.exports = __webpack_public_path__ + "img/gladiadoras.f94a160b.png";